/*
This was copied from the redux library. It lets us clean up multiple HOCs.

like:

export default compose(
    withNuiIntl,
    withNuiFormatter,
)(AppHeader);

instead of:

export default withNuiIntl(withNuiFormatter(AppHeader))
*/
export default function compose(...funcs) {
    if (funcs.length === 0) {
        return (arg) => arg;
    }

    if (funcs.length === 1) {
        return funcs[0];
    }

    return funcs.reduce((a, b) => (...args) => a(b(...args)));
}
